export const useAriaStatusMessage = (initialMessage = '') => {
	const message = ref(initialMessage);

	return computed({
		get: () => message.value,
		set: (value: string) => {
			message.value = value;
			setTimeout(() => {
				message.value = '';
			}, 1000);
		},
	});
};
